export const selectors = {
    contactFormWrapper: '.js-contact-form-wrapper',
    contactForm: '.js-contact-form',
    enquiryType: '.js-enquiry-type',
    fullName: '.js-full-name',
    email: '.js-email',
    telephone: '.js-telephone',
    message: '.js-message',
    projectName: '.js-project-name',
    projectStage: '.js-project-stage',
    filmTitleFestivalName: '.js-film-title-festival-name',
    screeningOrSalesNeeds: '.js-screening-or-sales-needs',
    productionTitle: '.js-production-title',
    expectedStartDate: '.js-expected-start-date',
    locationsOfInterest: '.js-locations-of-interest',
    submitButton: '.js-submit-button',
    successMessage: '.js-success-message',
    errorMessage: '.js-error-message',
    formIdInput: '.js-form-id',
    privacyPolicyText: '.js-privacy-policy-text',
    allDropdowns: '.js-dropdown',
    sendingAnimation: '.js-sending-animation',
};

const contactFormWrapper = document.querySelector(selectors.contactFormWrapper);

export const elements = {
    contactForm: contactFormWrapper?.querySelector(selectors.contactForm),
    enquiryType: contactFormWrapper?.querySelector(selectors.enquiryType),
    fullName: contactFormWrapper?.querySelector(selectors.fullName),
    email: contactFormWrapper?.querySelector(selectors.email),
    telephone: contactFormWrapper?.querySelector(selectors.telephone),
    message: contactFormWrapper?.querySelector(selectors.message),
    projectName: contactFormWrapper?.querySelector(selectors.projectName),
    projectStage: contactFormWrapper?.querySelector(selectors.projectStage),
    filmTitleFestivalName: contactFormWrapper?.querySelector(selectors.filmTitleFestivalName),
    screeningOrSalesNeeds: contactFormWrapper?.querySelector(selectors.screeningOrSalesNeeds),
    productionTitle: contactFormWrapper?.querySelector(selectors.productionTitle),
    expectedStartDate: contactFormWrapper?.querySelector(selectors.expectedStartDate),
    locationsOfInterest: contactFormWrapper?.querySelector(selectors.locationsOfInterest),
    submitButton: contactFormWrapper?.querySelector(selectors.submitButton),
    successMessage: contactFormWrapper?.querySelector(selectors.successMessage),
    errorMessage: contactFormWrapper?.querySelector(selectors.errorMessage),
    formIdInput: contactFormWrapper?.querySelector(selectors.formIdInput),
    privacyPolicyText: contactFormWrapper?.querySelector(selectors.privacyPolicyText),
    allDropdowns: contactFormWrapper?.querySelectorAll(selectors.allDropdowns),
    sendingAnimation: contactFormWrapper?.querySelector(selectors.sendingAnimation),
};
